import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import '../../../libs/css/dataTable.css';
import Nulls from '../Nulls';
import FilterComponent from './FilterComponent';
import { format } from 'date-fns';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';


function ChargingSyncTable(props) {
    const { capitalizeWords, isLoading, columns, dataTotal, dataList, countPerPage, setPage, handleChanges, isFade, handleFilters, openBearerID, openService, openNtwk, handleNtwks, handleNetworkChange, handleBearerID, handleOthers, registerName, handleOthersChange, clearInputs, handleAllNetworks } = props;

    const ExpandedComponent = ({ data }) => (
        <div className='text-left th_data'>
            <div><font>Applied Plan:</font> {data.appliedPlan ? data.appliedPlan : <Nulls />}</div>
            <div><font>Charging Mode:</font> {data.chargingMode ? data.chargingMode : <Nulls />}</div>
            <div><font>Bearer Id:</font> {data.bearerId ? data.bearerId : <Nulls />}</div>
            <div><font>Requested Plan:</font> {data.requestedPlan ? data.requestedPlan : <Nulls />}</div>
            <div><font>Service Id:</font> {data.serviceId ? data.serviceId : <Nulls />}</div>
            <div><font>Reference:</font> {data.reference ? data.reference : <Nulls />}</div>
            <div><font>Date Created:</font> {data.created_at ? format(new Date(data.created_at), 'MMM d, yyyy h:mma') : <Nulls />}</div>
        </div>
    );


    return (
        <div className="App">

            {
                isLoading ? 
                <LoadingSpinner />
                :
                <>
                    
                    <FilterComponent handleChanges={handleChanges} handleFilters={handleFilters} openBearerID={openBearerID} openService={openService} openNtwk={openNtwk} handleNtwks={handleNtwks} handleAllNetworks={handleAllNetworks} handleNetworkChange={handleNetworkChange} handleBearerID={handleBearerID} handleOthers={handleOthers} registerName={registerName} handleOthersChange={handleOthersChange} clearInputs={clearInputs} />

                    <div style={{ opacity: isFade ? '0.3' : 1 }} >
                    <DataTable
                        className="services_datatable users"
                        title=""
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        columns={columns}
                        data={dataList}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={dataTotal}
                        paginationPerPage={countPerPage}
                        paginationComponentOptions={{
                        noRowsPerPage: true
                        }}
                        onChangePage={page => setPage(page)}
                    />

                    {dataTotal <= 0 && <div className='mt-20'>Please filter on the filter boxes above to populate data</div>} 
                    </div>
                </>
            }
            
        </div>
    );
}

export default ChargingSyncTable;
